import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * ログイン、ダッシュボード画面ログインサービス
 *
 * @export ExecuteLoginService
 * @class ExecuteLogin
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class ExecuteLoginService extends PlessJsonResponderSub<any> {

  // パラメータ
  param: any;

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof ExecuteLoginService
   */
  private successFunc: (model: any) => void = null;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub,
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof ExecuteLoginService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        UserID: this.param.userID,
        UserPassWord: this.param.passWord,
        Fingerprint: this.param.fingerprint
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {*} param パラメータ
   * @memberof ExecuteLoginService
   */
  execute(param: { userID: string, passWord: string, fingerprint: string },
    successFunc: (model: any) => void): void {
    this.param = param;
    this.successFunc = successFunc;
    this.send('executeLogin', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof ExecuteLoginService
   */
  success(data: any): void {
    if (this.successFunc) {
      this.successFunc(data);
    }
  }

  /**
   * サーバーリクエスト失敗時に呼び出されるメソッド。
   *
   * @param {*} errList レスポンスのデータ部分(Son)
   * @memberof ExecuteLoginService
   */
  plessErrorHandler(errList: any): void {
    // 標準処理を続行
    super.plessErrorHandler(errList);
  }
}
